export default __webpack_public_path__ + "static/media/bice_rusia.07018af9.png";